import { Button, Card, Col, Modal, Spinner } from "react-bootstrap";
import CardTitle from "../organisms/CardTitle";
import styled from "styled-components";
import Calendar from "../organisms/Calendar";
import SuccessButton from "../organisms/SuccessButton";
import { useMemo, useState } from "react";
import { formatearFecha, obtenerStringDeFecha } from "../../utils/dateUtils";

function ReagendamientoModal({
  itemAsistencia,
  onClose,
  fecha,
  onGuardar,
  fechasIsLoading,
  fechasOcupadas,
  guardando = false,
  maxDate,
}: {
  itemAsistencia: { nombreMascota: string; nombrePropietario: string };
  fecha: Date;
  onClose: () => void;
  fechasOcupadas: Date[];
  onGuardar: (fechasReemplazadas: Map<string, string>) => void;
  fechasIsLoading: boolean;
  guardando?: boolean;
  maxDate?: Date;
}) {
  const [fechaSeleccionada, setFechaSeleccionada] = useState<Date | undefined>(
    undefined
  );

  const fechasNoDisponibles = useMemo(() => {
    if (fechasOcupadas === undefined) return [];
    let noDisponibles = fechasOcupadas.slice();
    noDisponibles.push(fecha);
    return noDisponibles;
  }, [fechasOcupadas, fecha]);

  const onDateClick = (fecha: Date) => {
    setFechaSeleccionada(fecha);
  };

  const onGuardarClick = () => {
    if (fechaSeleccionada) {
      const fechaOriginal = obtenerStringDeFecha(fecha);
      const fechaNueva = obtenerStringDeFecha(fechaSeleccionada);
      const fechasMap = new Map<string, string>();
      fechasMap.set(fechaOriginal, fechaNueva);

      onGuardar(fechasMap);
    }
  };

  return (
    <Modal show={true} centered>
      <Modal.Body>
        <StyledCard>
          <StyledCardHeader className="mt-3">
            <Col className="justify-content-center align-items-center text-center">
              <CardTitle>{"Reagendamiento"}</CardTitle>
            </Col>
          </StyledCardHeader>
          <StyledCardBody>
            <div className="mb-3">
              <b>{"Fecha de asistencia: "}</b>
              {formatearFecha(fecha)}
            </div>
            <div className="mb-3">
              <b>{"Mascota: "}</b>
              {itemAsistencia.nombreMascota}
            </div>
            <div className="mb-3">
              <b>{"Propetario: "}</b>
              {itemAsistencia.nombrePropietario}
            </div>
            <hr></hr>
            <div className="mb-3">{"Elegir fecha de re-programación: "}</div>
            <div>
              {fechasIsLoading ? (
                "Cargando..."
              ) : (
                <StyledCalendar
                  onDateClick={onDateClick}
                  disabledDates={fechasNoDisponibles}
                  allowPartialRange={false}
                  disableSelection={true}
                  minDate={new Date()}
                  maxDate={maxDate}
                />
              )}
            </div>
          </StyledCardBody>
        </StyledCard>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          variant="success"
          onClick={onGuardarClick}
          disabled={!fechaSeleccionada || fechasIsLoading || guardando}
        >
          {guardando && <Spinner animation="border" size="sm" />}
          {guardando ? " Guardando..." : "Guardar"}
        </SuccessButton>
        <Button variant="danger" onClick={onClose} disabled={guardando}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const StyledCalendar = styled(Calendar)`
  width: 100%;
  border-radius: 5px;
  padding: 0%;
`;

const StyledCard = styled(Card)`
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: start;
  align-items: center;
  border: 0px;
`;

export default ReagendamientoModal;
